import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { CustomProductsService } from '../../custom-landing/custom-products/custom-products.service';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import InventoryManagementService from '../../custom-landing/inventory-unpublished-batch/inventory-management.service';
import { ToastrService } from 'ngx-toastr';
import { NgIf } from '@angular/common';
import { CustomFooterComponent } from '../custom-footer/custom-footer.component';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-custom-copyright',
    templateUrl: './custom-copyright.component.html',
    styleUrls: ['./custom-copyright.component.scss'],
    host: {
        '(window:resize)': 'onResize($event)'
    },
    imports: [NgIf, RouterLink, CustomFooterComponent, I18nModule]
})
export class CustomCopyrightComponent implements OnInit {
  enableLoader = false;
  page = 0;
  privacyPolicyStr: any;
  termsOfUseStr: any;
  termsOfUseText:any;
  securityNum: any;
  icpNum: any;
  ICPNoLink: any;
  securityNoLink: any;
  chinaInstance: any;
  b2bunits: any;
  errorMessage: any;
  currentRoute:string;
  //commenting as we are not using it 
  // displayShipdocsFlag: boolean;
  CookiePolicyLink: any;
  copyrightInfo: any;
  userid: string;
  termsOfUsePartner: any;
  showTermsofUseText:boolean=false;
  constructor(private router: Router,
    private toastService: ToastrService,
    private customProfileService: CustomProfileService,
    private customProductService: CustomProductsService,
    private inventoryManagementService: InventoryManagementService,
    public cd: ChangeDetectorRef) {
      this.router.events.subscribe((event) =>{
        if(event instanceof NavigationEnd){
          if((this.router.url === '/') || (this.router.url === '/login') || 
          (this.router.url.includes('shipmentvmslist')==true)   || (this.router.url.includes('dvl-tracking-list')==true) || 
          (this.router.url.includes('dvl-tracking-details')==true) || (this.router.url.includes('vmsdetails')==true) || this.router.url.includes('portside') ||  this.router.url.includes('bondedwarehouse')) 
          {
            setTimeout(() => {
              this.showTermsofUseText =true;
              console.log(this.showTermsofUseText)
              this.cd.detectChanges();
           }, 2000);
          }
          else{
            setTimeout(() => {
              this.showTermsofUseText =false;
              console.log(this.showTermsofUseText)
              this.cd.detectChanges();
            }, 2000);
          }
         
        }
      } );
  }

  ngOnInit(): void {
   
    //this.getFooterData(); commenting as we are not using
    this.getcopyrightsdata();
    this.currentRoute= this.router.url;
    const resolution = window.innerWidth;
    if(this.router){
      if (resolution < 994) {
        if (this.router.url === '/login' || this.router.url === '/login/forgot-password' || this.router.url === '/login/otp') {
          document.querySelector<HTMLElement>('.remove-extra-space').classList.add('mb-mobile');
        } else {
          document.querySelector<HTMLElement>('.remove-extra-space').classList.remove('mb-mobile');
        }
      }
      
    }
   
    this.customProductService.languageChange$.subscribe(data => {
  
      if (data != null) {
        setTimeout(() => {
          this.inventoryManagementService.getHelpData().subscribe(resp => {
            if (resp) {
              this.securityNum = resp.securityNo ? resp.securityNo : "";
              this.icpNum = resp.ICPNo ? resp.ICPNo : "";
              this.chinaInstance = resp.chinaInstanceCheck;
              this.ICPNoLink = resp.ICPNoLink ? resp.ICPNoLink : "";
              this.securityNoLink = resp.securityNoLink ? resp.securityNoLink : "";
              this.privacyPolicyStr = resp.privacyPolicy ? resp.privacyPolicy : "";
              this.termsOfUseStr = resp.termsOfUse ? resp.termsOfUse : "";
              this.CookiePolicyLink = resp.cookiesPolicy ? resp.cookiesPolicy : "";
              this.copyrightInfo = resp.copyrightInfo ? resp.copyrightInfo : "";
              this.termsOfUseText = resp.termsOfUseText ? resp.termsOfUseText : ""; 
              if (this.copyrightInfo != "") {
                this.copyrightInfo = "© " + this.copyrightInfo;
              }
              this.cd.detectChanges();
            }
            else {
              this.toastService.show('Error loading this page:' + (resp));
            }
          });
          
        }, 2000);
       
      }
    },
      err => {
        this.errorMessage = err;
        this.toastService.show("Sorry something went wrong, please try again!")
      });
  }
  onResize(event) {
    if (event.target.innerWidth < 994) {
      if (this.router.url === '/login' || this.router.url === '/login/forgot-password' || this.router.url === '/login/otp') {
        document.querySelector<HTMLElement>('.remove-extra-space').classList.add('mb-mobile');
      } else {
        document.querySelector<HTMLElement>('.remove-extra-space').classList.remove('mb-mobile');
      }
    }
  }

  // getFooterData() { commenting as we are not using
  //   if(this.userid){
  //     this.customProfileService.getBhpUnitList().subscribe(res => {

  //       this.b2bunits = res && res.myB2BUnits;
  //       //this.menuDisplay = [...this.b2bunits[0].menuDisplay];
  //       this.displayShipdocsFlag = res && res.myB2BUnits && res.myB2BUnits.shipsDocdisplayFlag;
  //       this.cd.detectChanges();
  //     });
  //   }
  // }
  getcopyrightsdata() {
    setTimeout(() => {
      this.inventoryManagementService.getHelpData().subscribe((resp: any) => {

      this.customProductService.setprivacyValues(resp);
        if (resp) {
          this.securityNum = resp.securityNo ? resp.securityNo : "";
          this.icpNum = resp.ICPNo ? resp.ICPNo : "";
          this.chinaInstance = resp.chinaInstanceCheck;
          this.ICPNoLink = resp.ICPNoLink ? resp.ICPNoLink : "";
          this.securityNoLink = resp.securityNoLink ? resp.securityNoLink : "";
          this.privacyPolicyStr = resp.privacyPolicy ? resp.privacyPolicy : "";
          this.termsOfUseStr = resp.termsOfUse ? resp.termsOfUse : "";
          this.CookiePolicyLink = resp.cookiesPolicy ? resp.cookiesPolicy : "";
          this.copyrightInfo = resp.copyrightInfo ? resp.copyrightInfo : "";
          this.termsOfUseText = resp.termsOfUseText ? resp.termsOfUseText : "";
          this.termsOfUsePartner = resp.termsOfUsePartner?resp.termsOfUsePartner:"";
          if (this.copyrightInfo != "") {
            this.copyrightInfo = "© " + this.copyrightInfo;
          }
          this.cd.detectChanges();
        }
  
      });
    }, 2000);
   
  }
}
